/**
 * App script
 */
import '@images/i-menu.png';
import FriendlyCaptcha from '@scripts/services/FriendlyCaptcha';
import '@styles/app.css';

document.addEventListener('DOMContentLoaded', () => {
  new FriendlyCaptcha().init();
});
